import PropTypes from 'prop-types';
import React from 'react';

export const EventCalendarItem = ({ event }) => event.title;

EventCalendarItem.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
};
